import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProfileTypes, serverUrl } from 'src/app/shared/constants';
import { UtilitiesService } from '../../services/utilities/utilities.service';

@Component({
    selector: 'app-user-guide-preview',
    templateUrl: './user-guide-preview.component.html',
    styleUrls: ['./user-guide-preview.component.scss'],
    standalone: false
})
export class UserGuidePreviewComponent implements OnInit {

  serverUrl = serverUrl;
  userType: number;
  selectedUserGuide: string;
  isAdmin = false;
  userGuideTypes = ['Administrator', 'Playbook Owner', 'Sales Manager', 'User'];
  adminText = 'Select a user type below to download the guide for the given role:';
  nonAdminText = 'Click below to download the User Guide and begin learning how to use vPlaybook.';

  constructor(
    private utilitiesService: UtilitiesService,
    private modalRef: BsModalRef,
  ) { }

  ngOnInit() {
    this.selectedUserGuide = this.userGuideTypes[0];
    if (this.userType === 1 || this.userType === 2 || this.userType === 3) {
      this.isAdmin = true;
    }
  }

  /**
   * To download the UserGuide accoriding to selection or profile type
   */
  downloadUserGuide() {
    let role = 0;
    if (this.isAdmin) {
      switch (this.selectedUserGuide) {
        case this.userGuideTypes[0]:
          role = ProfileTypes.SuperVPlaybookAdmin;
          break;
        case this.userGuideTypes[1]:
          role = ProfileTypes.PlaybookOwner;
          break;
        case this.userGuideTypes[2]:
          role = ProfileTypes.SalesManager;
          break;
        case this.userGuideTypes[3]:
          role = ProfileTypes.User;
          break;
      }
    } else {
      role = this.userType;
    }
    this.utilitiesService.getAssetAzureUrl('/api/Settings/GetUserGuide?role=' + role);
  }

  closeModal() {
    this.modalRef.hide();
  }
}
